const stickyOrderForm = document.querySelector('[data-js="pdp-sticky-orderform"]');

if (stickyOrderForm) {
    const target = document.querySelector('[data-js="pdp-sticky-entry-point"]');

    const thresholdArray = steps => Array(steps + 1)
        .fill(0)
        .map((_, index) => index / steps || 0);

    const observerOptions = {
        root: document,
        threshold: thresholdArray(20),
        rootMargin: "-95px"
    };

    let previousY = 0
    let previousRatio = 0

    const handleIntersect = entries => {
        entries.forEach(entry => {
          const currentY = entry.boundingClientRect.y
          const currentRatio = entry.intersectionRatio

     
          if (currentY < previousY && currentRatio < previousRatio) {
              stickyOrderForm.classList.remove('_hidden');

          } else if (currentY > previousY && currentRatio > previousRatio) {
              stickyOrderForm.classList.add('_hidden');
          }
      
          previousY = currentY
          previousRatio = currentRatio
        })
      }
      
    const observer = new IntersectionObserver(handleIntersect, observerOptions);
    
    observer.observe(target)
}